<template>
  <vs-row vs-align="center" vs-type="flex" vs-justify="center" vs-w="12">
    <select
      v-model="user_role_id"
      name="cars"
      id="cars"
      form="carform"
      class="w-100 selectExample mt-2"
      style="height:30px;border:1px solid grey;"
    >
      <option value disabled selected hidden>Choose Role</option>
      <option
        :key="index"
        :value="item.user_role_id"
        :label="item.role_name"
        v-for="(item,index) in options1"
      ></option>
    </select>
  </vs-row>
</template>
<script>
import { role_list } from '@/api/user'
export default {
  data () {
    return {
      options1: [],
      user_role_id: null
    }
  },
  mounted () {
    role_list()
      .then((res) => {
        
        this.options1 = res.data.data.role_list
      })
      .catch((e) => {
        
      })
  }
}
</script>
